import React from 'react';

function BlockE() {
  const employmentData = [
    // Part A: details for each category of staff
    {
      slNo: 1,
      category: 'Male Workers Employed directly',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 2,
      category: 'Female Workers Employed directly',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 3,
      category: 'Sub-Total (1+2)',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 4,
      category: 'Workers Employed through Contractors',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 5,
      category: 'Total Workers (3+4)',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 6,
      category: 'Supervisory & Managerial Staff',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 7,
      category: 'Other Employees',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 8,
      category: 'Unpaid Family Members/Proprietor/Coop. Members',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 9,
      category: 'Total Employees (5+6+7+8)',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    // Part B: some details for all categories of staff combined
    {
      slNo: 10,
      category: 'Bonus(in Rs.)',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 11,
      category: 'Contribution to Provident Fund and Other Funds (in Rs.)',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    },
    {
      slNo: 12,
      category: 'Workman and Staff Welfare Expenses (in Rs.)',
      mandaysManufacturing: 0,
      mandaysNonManufacturing: 0,
      mandaysTotal: 0,
      avgPersonsWorked: 0,
      mandaysPaidFor: 0,
      wagesSalaries: 0
    }
  ];

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  return (
    <>
      <style>
        {`
          .block-e-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .reference-numbers {
            color: #333;
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
          .employment-table {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 20px;
          }
          .table-header {
            background-color: #f8f9fa;
            border-bottom: 2px solid #1976d2;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 12px;
            text-align: center;
            vertical-align: middle;
            padding: 12px 6px;
            border: 1px solid #dee2e6;
            white-space: nowrap;
          }
          .table td {
            font-size: 12px;
            text-align: center;
            vertical-align: middle;
            padding: 8px 6px;
            border: 1px solid #dee2e6;
          }
          .table td:first-child {
            text-align: center;
            font-weight: 600;
            width: 50px;
          }
          .table td:nth-child(2) {
            text-align: left;
            font-weight: 500;
            min-width: 250px;
          }
          .table td:nth-child(3),
          .table td:nth-child(4),
          .table td:nth-child(5),
          .table td:nth-child(6),
          .table td:nth-child(7),
          .table td:nth-child(8) {
            text-align: right;
            font-weight: 500;
            width: 100px;
          }
          .subtotal-row {
            background-color: #f8f9fa;
            font-weight: 600;
          }
          .total-row {
            background-color: #e3f2fd;
            font-weight: bold;
            color: #1976d2;
          }
          .section-title {
            background-color: #f0f0f0;
            font-weight: bold;
            text-decoration: underline;
            padding: 8px 12px;
            margin: 0;
            border-bottom: 1px solid #ddd;
          }
          .working-days-section {
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 15px;
            margin-bottom: 20px;
          }
          .working-days-title {
            font-weight: bold;
            color: #1976d2;
            margin-bottom: 15px;
          }
          .working-days-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0;
            border-bottom: 1px solid #eee;
          }
          .working-days-row:last-child {
            border-bottom: none;
            font-weight: 600;
          }
          .total-cost-section {
            background-color: #fff3cd;
            border: 1px solid #ffeaa7;
            border-radius: 6px;
            padding: 15px;
            margin-top: 20px;
          }
          .total-cost-label {
            font-weight: bold;
            color: #856404;
            margin-bottom: 10px;
          }
          .total-cost-formula {
            font-size: 12px;
            color: #666;
            font-style: italic;
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="block-e-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">E: EMPLOYMENT AND LABOUR COST</h1>
            </div>
            <div className="col-md-6 text-end">
              <p className="reference-numbers">DSL No : 404936</p>
              <p className="reference-numbers">PSL No : 31186</p>
            </div>
          </div>
        </div>

        {/* Employment Table */}
        <div className="employment-table">
          <div className="table-responsive">
            <table className="table table-bordered mb-0">
              <thead className="table-header">
                <tr>
                  <th rowSpan="2">SI No</th>
                  <th rowSpan="2">Category of staff</th>
                  <th colSpan="3">Mandays Worked</th>
                  <th rowSpan="2">Average Number of persons worked</th>
                  <th rowSpan="2">No. of Mandays Paid for</th>
                  <th rowSpan="2">Wages/ Salaries (in Rs.)</th>
                </tr>
                <tr>
                  <th>Manufacturing</th>
                  <th>Non Manufacturing</th>
                  <th>Total</th>
                </tr>
                <tr>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                  <th>6</th>
                  <th>7</th>
                  <th>8</th>
                </tr>
              </thead>
              <tbody>
                {/* Part A Section */}
                <tr>
                  <td colSpan="8" className="section-title">Part A: details for each category of staff</td>
                </tr>
                {employmentData.slice(0, 9).map((row, index) => (
                  <tr key={index} className={
                    row.category.includes('Sub-Total') || row.category.includes('Total Workers') || 
                    row.category.includes('Total Employees') ? 'subtotal-row' : ''
                  }>
                    <td>{row.slNo}</td>
                    <td>{row.category}</td>
                    <td>{formatNumber(row.mandaysManufacturing)}</td>
                    <td>{formatNumber(row.mandaysNonManufacturing)}</td>
                    <td>{formatNumber(row.mandaysTotal)}</td>
                    <td>{formatNumber(row.avgPersonsWorked)}</td>
                    <td>{formatNumber(row.mandaysPaidFor)}</td>
                    <td>{formatNumber(row.wagesSalaries)}</td>
                  </tr>
                ))}
                
                {/* Part B Section */}
                <tr>
                  <td colSpan="8" className="section-title">Part B: some details for all categories of staff combined</td>
                </tr>
                {employmentData.slice(9, 12).map((row, index) => (
                  <tr key={index + 9}>
                    <td>{row.slNo}</td>
                    <td>{row.category}</td>
                    <td>{formatNumber(row.mandaysManufacturing)}</td>
                    <td>{formatNumber(row.mandaysNonManufacturing)}</td>
                    <td>{formatNumber(row.mandaysTotal)}</td>
                    <td>{formatNumber(row.avgPersonsWorked)}</td>
                    <td>{formatNumber(row.mandaysPaidFor)}</td>
                    <td>{formatNumber(row.wagesSalaries)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Number of Working Days Section */}
        <div className="working-days-section">
          <div className="working-days-title">Number of Working Days (Item 13)</div>
          <div className="working-days-row">
            <span>1. Manufacturing days:</span>
            <span>0</span>
          </div>
          <div className="working-days-row">
            <span>2. Non-manufacturing days:</span>
            <span>0</span>
          </div>
          <div className="working-days-row">
            <span>3. Total (1+2):</span>
            <span>0</span>
          </div>
        </div>

        {/* Total Cost of Production Section */}
        <div className="total-cost-section">
          <div className="total-cost-label">Total Cost of Production (in Rs.): 0</div>
          <div className="total-cost-formula">
            [Entry in col. 8 of item 9, 10,11 & 12 of Bl. E (+) entry in col. 3 of item (1 to 10) of Bl. F (+) entry in col.6 of item 23 of Bl. H (+) entry in col. 6 of item 7 of Bl. I]
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1">
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockE; 